import { BaseFieldModel, IBaseFieldModel } from '../base/blueprint-field-base.model';

export interface IFieldURLModel extends IBaseFieldModel {
  isRequired: boolean;
  isReadOnly: boolean;
  value: string;
}

export class FieldURLModel extends BaseFieldModel implements IFieldURLModel {
  constructor(
    public isRequired: boolean,
    public isReadOnly: boolean,
    public value: string,
  ) {
    super(isRequired, isReadOnly);
  }
}
